// Regreso a otra aplicación del mismo dominio después de iniciar sesión
// (ProDominicana Learning Lab en /learning usa este login). Solo se aceptan
// rutas bajo /learning para no abrir redirecciones a sitios externos.
const CLAVE = 'protalenthub_volver_a';

const esDestinoValido = (ruta) => typeof ruta === 'string' && /^\/learning(\/|$|\?)/.test(ruta);

export const guardarVolverA = (ruta) => {
  if (esDestinoValido(ruta)) sessionStorage.setItem(CLAVE, ruta);
};

// Devuelve el destino guardado (y lo borra) o null
export const tomarVolverA = () => {
  const ruta = sessionStorage.getItem(CLAVE);
  sessionStorage.removeItem(CLAVE);
  return esDestinoValido(ruta) ? ruta : null;
};
